export const PARENT_LIST_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';
export const PARENT_DETAIL_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';
// {parentId}/{childId}
export const CHILD_DETAIL_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';

export const UPDATE_PARENT_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';

export const DELETE_PARENT_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';

export const SEND_CUSTOM_MESSAGE_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/users/notify/custom';

export const DELETE_CHILD_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';

export const UPDATE_CHILD_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/parents';

export const GET_LOG_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/logs';

export const GET_GIFT_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/giftcards';

export const GET_ADMIN_USERS_API =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/users';

export const DELETE_ADMIN_USER =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/users';

export const CREATE_ADMIN_USER =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/user';

export const GET_ADMIN_DETAIL =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/users';

export const UPDATE_ADMIN =
  'https://ibqd7manee.execute-api.us-east-1.amazonaws.com/dev/users';
